import { render, staticRenderFns } from "./ReusableCard.vue?vue&type=template&id=75a21fc1&scoped=true&"
import script from "./ReusableCard.vue?vue&type=script&lang=ts&"
export * from "./ReusableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReusableCard.vue?vue&type=style&index=0&id=75a21fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a21fc1",
  null
  
)

export default component.exports